import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { Product } from 'src/app/shared/classes/product';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
	selector: 'product-default-page',
	templateUrl: './default.component.html',
	styleUrls: ['./default.component.scss']
})

export class DefaultPageComponent implements OnInit {

	product: Product;
	prev: Product;
	next: Product;
	related = [];
	loaded = false;

	constructor(
		public apiService: ApiService,
		private activeRoute: ActivatedRoute,
		public router: Router,
		private titleService:Title
	) {
		/*
		activeRoute.params.subscribe(params => {
			this.loaded = false;
			this.apiService.getSingleProduct(params['id']).subscribe(result => {
				if (result === null) {
					this.router.navigate(['/pages/404']);
				}

				this.product = result.product;
				this.prev = result.prevProduct;
				this.next = result.nextProduct;
				this.related = result.product.relatedProducts;//these should be the suggested products
				this.loaded = true;
			});
		});
		*/
	}

	async ngOnInit(): Promise<void> {
		if(typeof window !== 'undefined'){
			if(this.apiService.db_conn_string == null || this.apiService.db_conn_string == ''){
				await this.apiService.fetchDBconnStringPromise();
			}
			
			this.activeRoute.params.subscribe(async params => {
				this.loaded = false;
				let result =  await lastValueFrom(this.apiService.getSingleProductPromise(params['id'],true));
					if (result === null) {
						this.router.navigate(['/pages/404']);
					}
					this.product = result.product;
					this.prev = result.prevProduct;
					this.next = result.nextProduct;				
					//this.related = result.product.relatedProducts;//these should be the suggested products
					if(result.product.relatedProducts.length >0){					
						for(let i=0; i<result.product.relatedProducts.length;i++){						
							let tmp = await lastValueFrom(this.apiService.getSingleProductPromise(result.product.relatedProducts[i].id));
							this.related.push(tmp.product);									
						}										
					}
					this.loaded = true;
				});	
			
		}
	}
}